import script from "./LocaleSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocaleSelector.vue?vue&type=script&setup=true&lang=ts"

import "./LocaleSelector.vue?vue&type=style&index=0&id=582bbedd&lang=scss"

const __exports__ = script;

export default __exports__